/**
 * Helpers de mapeo compartidos por los services de Chispas (`point-rules.ts`, `point-rewards.ts`).
 * Leen respuestas `unknown` del backend de forma defensiva y arman bodies snake_case desde una
 * lista blanca de campos.
 */

export const unwrapApiData = (response: unknown): unknown => {
  if (typeof response !== "object" || response === null) {
    return response;
  }
  const record = response as Record<string, unknown>;
  return record.success === true && record.data !== undefined ? record.data : response;
};

export const hasOwnKey = (record: object, key: unknown): boolean =>
  typeof key === "string" && Object.prototype.hasOwnProperty.call(record, key);

export const toNumberOrNull = (value: unknown): number | null => {
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return typeof value === "number" && Number.isFinite(value) ? value : null;
};

export const toNumberOr = (value: unknown, fallback: number): number =>
  toNumberOrNull(value) ?? fallback;

export const toStr = (value: unknown): string => (typeof value === "string" ? value : "");

export const toNullableStr = (value: unknown): string | null =>
  typeof value === "string" && value.trim() !== "" ? value : null;

/**
 * Body snake_case con SOLO los campos de la lista blanca que tienen valor: null viaja (vacía el
 * campo), undefined no. Lo que no está en `bodyKeys` nunca sale, y eso es lo que evita mandar
 * tenant_id o id a un endpoint `.strict()`.
 */
export const toSnakeCaseChangesBody = <Field extends string>(
  changes: Partial<Record<Field, unknown>>,
  bodyKeys: Record<Field, string>
): Record<string, unknown> => {
  const body: Record<string, unknown> = {};
  for (const field of Object.keys(bodyKeys) as Field[]) {
    const value = changes[field];
    if (value !== undefined) {
      body[bodyKeys[field]] = value;
    }
  }
  return body;
};
